type NavigateToWebAuthUrlOptions = {
  location?: Pick<Location, 'href' | 'assign' | 'replace' | 'reload'>;
  scheduleReload?: (callback: () => void) => void;
};

export function navigateToWebAuthUrl(
  nextUrl: string,
  options: NavigateToWebAuthUrlOptions = {},
) {
  const location = options.location ?? window.location;
  const scheduleReload = options.scheduleReload ?? ((callback: () => void) => window.setTimeout(callback, 0));
  const currentUrl = new URL(location.href, window.location.origin);
  const targetUrl = new URL(nextUrl, currentUrl.origin);
  const isHashOnlyNavigation = currentUrl.origin === targetUrl.origin
    && currentUrl.pathname === targetUrl.pathname
    && currentUrl.search === targetUrl.search
    && currentUrl.hash !== targetUrl.hash;

  if (isHashOnlyNavigation) {
    location.replace(nextUrl);
    scheduleReload(() => location.reload());
    return;
  }

  location.assign(nextUrl);
}
